import React, { useState } from 'react';
import { PlusIcon, SearchIcon, EditIcon, TrashIcon, TagIcon, CheckIcon, UploadIcon, ImageIcon, XIcon } from 'lucide-react';
import { labelColors } from '../constants/labels';
import { DragDropProductionSteps, availableProductionSteps } from './ProductForm';
function getRandomLabelsCount() {
  return Math.floor(Math.random() * 6) + 1;
}
const availableIngredients = [{
  id: 'ing1',
  productNumber: 'R001',
  name: 'Schweinefleisch',
  category: 'Fleisch'
}, {
  id: 'ing2',
  productNumber: 'R002',
  name: 'Rinderfleisch',
  category: 'Fleisch'
}, {
  id: 'ing3',
  productNumber: 'R003',
  name: 'Kalbfleisch',
  category: 'Fleisch'
}, {
  id: 'ing4',
  productNumber: 'G001',
  name: 'Salz',
  category: 'Gewürze'
}, {
  id: 'ing5',
  productNumber: 'G002',
  name: 'Pfeffer',
  category: 'Gewürze'
}, {
  id: 'ing6',
  productNumber: 'G003',
  name: 'Paprikapulver',
  category: 'Gewürze'
}, {
  id: 'ing7',
  productNumber: 'G004',
  name: 'Knoblauch',
  category: 'Gewürze'
}, {
  id: 'ing8',
  productNumber: 'G005',
  name: 'Majoran',
  category: 'Gewürze'
}, {
  id: 'ing9',
  productNumber: 'D001',
  name: 'Naturdarm',
  category: 'Därme'
}, {
  id: 'ing10',
  productNumber: 'D002',
  name: 'Kunstdarm',
  category: 'Därme'
}].sort((a, b) => a.name.localeCompare(b.name));
export const initialProducts = [{
  id: 'P006',
  productNumber: 'LJ-006',
  name: 'Landjäger Premium QS/TW',
  description: 'Premium Landjäger aus QS und Tierwohl zertifiziertem Fleisch',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sq9vsZAKZM91HF4ELNb8S5/snackis_mit_feiner_pfeffernote-53f7cc51c8851c5g4d6cbdf84ee2f2f3.png',
  ingredients: ['Schweinefleisch', 'Rindfleisch', 'Speck', 'Gewürze'],
  label: {
    type: 'loop',
    name: 'Schlaufenetikett',
    color: '#FFFFFF'
  },
  labelsPerProduct: getRandomLabelsCount(),
  productionSteps: [availableProductionSteps[0], availableProductionSteps[1], availableProductionSteps[2], availableProductionSteps[4]]
}];
const labelTypes = [{
  id: 'loop',
  name: 'Schlaufenetikett'
}, {
  id: 'stick',
  name: 'Klebeetikett'
}, {
  id: 'band',
  name: 'Banderole'
}, {
  id: 'hang',
  name: 'Hängeetikett'
}, {
  id: 'print',
  name: 'Direktdruck'
}] as const;
export function ProductDatabase() {
  const [products, setProducts] = useState(initialProducts);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState<null | (typeof initialProducts)[0]>(null);
  const [isEditing, setIsEditing] = useState(false);
  const handleNewProduct = () => {
    setSelectedProduct({
      id: `P${String(products.length + 1).padStart(3, '0')}`,
      name: '',
      description: '',
      image: '',
      ingredients: [],
      label: {
        type: '',
        name: '',
        color: ''
      },
      labelsPerProduct: getRandomLabelsCount(),
      productionSteps: [availableProductionSteps[0], availableProductionSteps[1], availableProductionSteps[2], availableProductionSteps[4]]
    });
    setIsEditing(true);
  };
  const filteredProducts = products.filter(product => product.name.toLowerCase().includes(searchTerm.toLowerCase()) || product.id.toLowerCase().includes(searchTerm.toLowerCase()) || product.productNumber.toLowerCase().includes(searchTerm.toLowerCase()));
  const handleSelectProduct = (product: (typeof initialProducts)[0]) => {
    setSelectedProduct(product);
    setIsEditing(false);
  };
  return <div className="p-6 h-full" data-id="element-409">
      <header className="mb-8" data-id="element-410">
        <h1 className="text-3xl font-bold text-[#e20019]" data-id="element-411">Produktdatenbank</h1>
        <p className="text-gray-600" data-id="element-412">
          Verwalten Sie Ihre Produkte und zugehörigen Etiketten
        </p>
      </header>
      <div className="flex flex-col lg:flex-row gap-6 h-[calc(100%-8rem)]" data-id="element-413">
        <div className="lg:w-1/3 flex flex-col" data-id="element-414">
          <div className="mb-4 flex gap-2" data-id="element-415">
            <div className="relative flex-1" data-id="element-416">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-417" />
              <input type="text" placeholder="Produkt suchen..." className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ec8301]" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-418" />
            </div>
            <button className="bg-[#ec8301] hover:bg-[#e20019] text-white rounded-lg px-4 py-2 flex items-center transition-colors" onClick={handleNewProduct} data-id="element-419">
              <PlusIcon className="h-5 w-5 mr-1" data-id="element-420" />
              <span data-id="element-421">Neu</span>
            </button>
          </div>
          <div className="bg-white rounded-lg shadow flex-1 overflow-auto" data-id="element-422">
            {filteredProducts.length === 0 ? <div className="p-4 text-center text-gray-500" data-id="element-423">
                Keine Produkte gefunden
              </div> : <ul className="divide-y divide-gray-200" data-id="element-424">
                {filteredProducts.map(product => <li key={product.id} data-id="element-425">
                    <button className={`w-full text-left p-4 hover:bg-gray-50 ${selectedProduct?.id === product.id ? 'bg-gray-100' : ''}`} onClick={() => handleSelectProduct(product)} data-id="element-426">
                      <div className="flex gap-3" data-id="element-427">
                        <div className="h-16 w-16 rounded-lg overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-428">
                          {product.image && <img src={product.image} alt={product.name} className="h-full w-full object-cover" data-id="element-429" />}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-430">
                          <div className="flex items-center gap-2" data-id="element-431">
                            <span className="font-medium text-gray-900" data-id="element-432">
                              {product.name}
                            </span>
                            <span className="text-sm text-[#ec8301]" data-id="element-433">
                              {product.productNumber}
                            </span>
                          </div>
                          <div className="text-sm text-gray-500 mt-1" data-id="element-434">
                            {product.ingredients.slice(0, 3).join(', ')}
                            {product.ingredients.length > 3 && ' ...'}
                          </div>
                          <div className="flex items-center gap-2 mt-1" data-id="element-435">
                            {product.label && <div className="flex items-center gap-1.5" data-id="element-436">
                                <div className="w-3 h-3 rounded-full" style={{
                          backgroundColor: product.label.color
                        }} data-id="element-437" />
                                <span className="text-sm text-gray-600" data-id="element-438">
                                  {product.label.name}
                                </span>
                              </div>}
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>)}
              </ul>}
          </div>
        </div>
        <div className="lg:w-2/3 bg-white rounded-lg shadow p-6 overflow-auto" data-id="element-439">
          {!selectedProduct ? <div className="h-full flex items-center justify-center text-gray-500" data-id="element-440">
              <p data-id="element-441">Wählen Sie ein Produkt aus oder erstellen Sie ein neues</p>
            </div> : isEditing ? <ProductForm product={selectedProduct} onSave={updatedProduct => {
          if (products.some(p => p.id === updatedProduct.id)) {
            setProducts(products.map(p => p.id === updatedProduct.id ? updatedProduct : p));
          } else {
            setProducts([...products, updatedProduct]);
          }
          setSelectedProduct(updatedProduct);
          setIsEditing(false);
        }} onCancel={() => {
          if (selectedProduct.name === '') {
            setSelectedProduct(null);
          }
          setIsEditing(false);
        }} data-id="element-442" /> : <ProductDetails product={selectedProduct} onEdit={() => setIsEditing(true)} onDelete={() => {
          setProducts(products.filter(p => p.id !== selectedProduct.id));
          setSelectedProduct(null);
        }} data-id="element-443" />}
        </div>
      </div>
    </div>;
}
interface ProductDetailsProps {
  product: (typeof initialProducts)[0];
  onEdit: () => void;
  onDelete: () => void;
}
function ProductDetails({
  product,
  onEdit,
  onDelete
}: ProductDetailsProps) {
  return <div className="space-y-6" data-id="element-444">
      <div className="flex justify-between items-start" data-id="element-445">
        <div data-id="element-446">
          <h2 className="text-2xl font-bold" data-id="element-447">{product.name}</h2>
          <p className="text-gray-500" data-id="element-448">
            Produktnummer: {product.productNumber}
          </p>
        </div>
        <div className="flex gap-2" data-id="element-449">
          <button onClick={onEdit} className="bg-[#ec8301] text-white rounded-lg p-2 hover:bg-[#ec8301]/90" data-id="element-450">
            <EditIcon className="h-5 w-5" data-id="element-451" />
          </button>
          <button onClick={onDelete} className="bg-gray-100 hover:bg-red-100 text-gray-700 hover:text-red-500 rounded-lg p-2" data-id="element-452">
            <TrashIcon className="h-5 w-5" data-id="element-453" />
          </button>
        </div>
      </div>
      <div className="h-48 bg-gray-100 rounded-lg overflow-hidden" data-id="element-454">
        {product.image ? <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-455" /> : <div className="w-full h-full flex items-center justify-center text-gray-400" data-id="element-456">
            <ImageIcon className="h-12 w-12" data-id="element-457" />
          </div>}
      </div>
      <div className="space-y-4" data-id="element-458">
        <div data-id="element-459">
          <h3 className="text-lg font-medium mb-2" data-id="element-460">Zugewiesenes Rezept</h3>
          <div className="bg-gray-50 rounded-lg p-3" data-id="element-461">
            {product.ingredients && product.ingredients.length > 0 ? <ul className="space-y-1.5" data-id="element-462">
                <li className="flex items-center" data-id="element-463">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#ec8301] mr-3" data-id="element-464" />
                  <span className="font-mono text-gray-500 w-20" data-id="element-465">
                    {product.ingredients[0] === 'Pfefferbeißer Rezept' ? 'R001' : 'R002'}
                  </span>
                  <span className="text-gray-700" data-id="element-466">
                    {product.ingredients[0] === 'Pfefferbeißer Rezept' ? 'Pfefferbeißer Rezept' : 'Salami Rezept'}
                  </span>
                </li>
              </ul> : <p className="text-gray-500 text-center py-2" data-id="element-467">
                Kein Rezept zugewiesen
              </p>}
          </div>
        </div>
        {product.label && <div data-id="element-468">
            <h3 className="text-lg font-medium mb-2" data-id="element-469">Etikett</h3>
            <div className="bg-gray-50 rounded-lg p-3" data-id="element-470">
              <div className="flex items-center gap-3" data-id="element-471">
                <div className="w-6 h-6 rounded-full" style={{
              backgroundColor: product.label.color
            }} data-id="element-472" />
                <div data-id="element-473">
                  <div className="font-medium text-gray-700" data-id="element-474">
                    {product.label.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-475">
                    Farbe:{' '}
                    {labelColors.find(c => c.hex === product.label?.color)?.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-476">
                    Etiketten pro Produkt: {product.labelsPerProduct || 1}
                  </div>
                </div>
              </div>
            </div>
          </div>}
        {product.productionSteps && product.productionSteps.length > 0 && <div data-id="element-477">
            <h3 className="text-lg font-medium mb-2" data-id="element-478">Produktionsablauf</h3>
            <div className="bg-gray-50 rounded-lg p-4" data-id="element-479">
              <div className="flex flex-col gap-2" data-id="element-480">
                {product.productionSteps.map((step, index) => {
              const Icon = step.icon;
              return <div key={step.id} className="flex items-center gap-3" data-id="element-481">
                      <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center" data-id="element-482">
                        <Icon className="h-4 w-4 text-gray-600" data-id="element-483" />
                      </div>
                      <span className="text-gray-700" data-id="element-484">{step.label}</span>
                      {index < product.productionSteps.length - 1 && <div className="flex-1 border-b border-dashed border-gray-300" data-id="element-485" />}
                    </div>;
            })}
              </div>
            </div>
          </div>}
      </div>
    </div>;
}
interface ProductFormProps {
  product: (typeof initialProducts)[0];
  onSave: (product: (typeof initialProducts)[0]) => void;
  onCancel: () => void;
}
function ProductForm({
  product,
  onSave,
  onCancel
}: ProductFormProps) {
  const [formData, setFormData] = useState({
    ...product,
    productionSteps: product.productionSteps || []
  });
  const [ingredientSearchTerm, setIngredientSearchTerm] = useState('');
  const [selectedLabelType, setSelectedLabelType] = useState(product.label?.type || '');
  const [selectedColor, setSelectedColor] = useState(labelColors.find(c => c.hex === product.label?.color) || labelColors[0]);
  const [isIngredientsOpen, setIsIngredientsOpen] = useState(false);
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [newIngredient, setNewIngredient] = useState('');
  const filteredIngredients = availableIngredients.filter(ingredient => ingredient.name.toLowerCase().includes(ingredientSearchTerm.toLowerCase()) || ingredient.category.toLowerCase().includes(ingredientSearchTerm.toLowerCase()) || ingredient.productNumber.toLowerCase().includes(ingredientSearchTerm.toLowerCase()));
  const handleIngredientToggle = (ingredientName: string) => {
    setFormData(prev => ({
      ...prev,
      ingredients: prev.ingredients.includes(ingredientName) ? prev.ingredients.filter(i => i !== ingredientName) : [...prev.ingredients, ingredientName]
    }));
  };
  const groupedIngredients = filteredIngredients.reduce((acc, ingredient) => {
    if (!acc[ingredient.category]) {
      acc[ingredient.category] = [];
    }
    acc[ingredient.category].push(ingredient);
    return acc;
  }, {} as Record<string, typeof availableIngredients>);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const addIngredient = () => {
    if (newIngredient.trim()) {
      setFormData({
        ...formData,
        ingredients: [...formData.ingredients, newIngredient.trim()]
      });
      setNewIngredient('');
    }
  };
  const removeIngredient = (index: number) => {
    const updatedIngredients = [...formData.ingredients];
    updatedIngredients.splice(index, 1);
    setFormData({
      ...formData,
      ingredients: updatedIngredients
    });
  };
  const addLabel = () => {
    if (selectedLabelType) {
      const labelType = labelTypes.find(lt => lt.id === selectedLabelType);
      if (labelType) {
        setFormData({
          ...formData,
          label: {
            type: labelType.id,
            name: labelType.name,
            color: selectedColor.hex
          }
        });
        setSelectedLabelType('');
      }
    }
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFormData({
        ...formData,
        image: imageUrl
      });
    }
  };
  const updateLabel = (type: string, color: (typeof labelColors)[0]) => {
    const labelType = labelTypes.find(lt => lt.id === type);
    if (labelType) {
      setFormData({
        ...formData,
        label: {
          type: labelType.id,
          name: labelType.name,
          color: color.hex
        }
      });
    }
  };
  return <form onSubmit={e => {
    e.preventDefault();
    onSave(formData);
  }} className="h-full" data-id="element-486">
      <div className="mb-8" data-id="element-487">
        <h2 className="text-2xl font-bold" data-id="element-488">
          {formData.id ? `Produkt bearbeiten: ${formData.id}` : 'Neues Produkt erstellen'}
        </h2>
      </div>
      <div className="flex gap-8 h-[calc(100%-10rem)]" data-id="element-489">
        <div className="flex-1 space-y-6 overflow-auto" data-id="element-490">
          <div data-id="element-491">
            <h3 className="text-lg font-medium mb-4" data-id="element-492">Produktbild</h3>
            <div className="border border-gray-300 rounded-lg overflow-hidden" data-id="element-493">
              {formData.image ? <div className="relative" data-id="element-494">
                  <img src={formData.image} alt="Vorschau" className="w-full h-64 object-cover" data-id="element-495" />
                  <button type="button" onClick={() => setFormData({
                ...formData,
                image: ''
              })} className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors" data-id="element-496">
                    <XIcon className="h-4 w-4" data-id="element-497" />
                  </button>
                </div> : <div className="p-6 text-center h-64 flex flex-col items-center justify-center bg-gray-50" data-id="element-498">
                  <ImageIcon className="h-12 w-12 text-gray-400 mb-3" data-id="element-499" />
                  <label className="cursor-pointer inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#ec8301] hover:bg-[#ec8301]/90" data-id="element-500">
                    <span data-id="element-501">Bild hochladen</span>
                    <input type="file" className="sr-only" accept="image/*" onChange={handleFileUpload} data-id="element-502" />
                  </label>
                  <p className="text-xs text-gray-500 mt-2" data-id="element-503">
                    PNG, JPG bis 10MB
                  </p>
                </div>}
            </div>
          </div>
          <div data-id="element-504">
            <h3 className="text-lg font-medium mb-4" data-id="element-505">Produktinformationen</h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-506">
              <div data-id="element-507">
                <label className="block text-sm font-medium mb-1" data-id="element-508">
                  Produktnummer
                </label>
                <input type="text" name="productNumber" value={formData.productNumber} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]" required placeholder="KL-XXX" data-id="element-509" />
              </div>
              <div data-id="element-510">
                <label className="block text-sm font-medium mb-1" data-id="element-511">
                  Produktname
                </label>
                <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]" required data-id="element-512" />
              </div>
            </div>
          </div>
          <div data-id="element-513">
            <h3 className="text-lg font-medium mb-4" data-id="element-514">Rezept</h3>
            <div className="relative" data-id="element-515">
              <div className="flex mb-3" data-id="element-516">
                <div className="relative flex-1" data-id="element-517">
                  <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-518" />
                  <input type="text" value={ingredientSearchTerm} onChange={e => setIngredientSearchTerm(e.target.value)} onFocus={() => setIsIngredientsOpen(true)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ec8301]" placeholder="Rezept suchen (Name oder Nummer)..." data-id="element-519" />
                </div>
                {isIngredientsOpen && <button type="button" onClick={() => setIsIngredientsOpen(false)} className="ml-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg" data-id="element-520">
                    <XIcon className="h-5 w-5" data-id="element-521" />
                  </button>}
              </div>
              <div className="bg-gray-50 rounded-lg p-3 min-h-[200px]" data-id="element-522">
                <div className="flex flex-wrap gap-2" data-id="element-523">
                  {formData.ingredients.map(ingredient => {
                  const ingredientDetails = availableIngredients.find(i => i.name === ingredient);
                  return <span key={ingredient} className="bg-[#ec8301] bg-opacity-10 text-[#ec8301] px-3 py-1 rounded-full text-sm flex items-center" data-id="element-524">
                        {ingredientDetails?.productNumber} - {ingredient}
                        <button type="button" onClick={() => handleIngredientToggle(ingredient)} className="ml-2 hover:text-[#e20019]" data-id="element-525">
                          ×
                        </button>
                      </span>;
                })}
                  {formData.ingredients.length === 0 && <div className="text-gray-500 text-center w-full py-2" data-id="element-526">
                      Kein Rezept ausgewählt
                    </div>}
                </div>
              </div>
              {isIngredientsOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-64 overflow-auto" data-id="element-527">
                  {/* Recipes Section */}
                  <div data-id="element-528">
                    <div className="px-4 py-2 bg-[#ec8301] bg-opacity-10 text-sm font-medium text-[#ec8301]" data-id="element-529">
                      Rezepte
                    </div>
                    <div className="px-4 py-2 hover:bg-gray-50 flex items-center cursor-pointer" onClick={() => {
                  const newIngredients = formData.ingredients.filter(ing => ing !== 'Pfefferbeißer Rezept' && ing !== 'Salami Rezept');
                  setFormData(prev => ({
                    ...prev,
                    ingredients: [...newIngredients, 'Pfefferbeißer Rezept']
                  }));
                }} data-id="element-530">
                      <div className="w-5 h-5 border border-gray-300 rounded mr-3 flex items-center justify-center" data-id="element-531">
                        {formData.ingredients.includes('Pfefferbeißer Rezept') && <CheckIcon className="w-4 h-4 text-[#ec8301]" data-id="element-532" />}
                      </div>
                      <span className="text-gray-500 mr-2" data-id="element-533">R001</span>
                      Pfefferbeißer Rezept
                    </div>
                    <div className="px-4 py-2 hover:bg-gray-50 flex items-center cursor-pointer" onClick={() => {
                  const newIngredients = formData.ingredients.filter(ing => ing !== 'Pfefferbeißer Rezept' && ing !== 'Salami Rezept');
                  setFormData(prev => ({
                    ...prev,
                    ingredients: [...newIngredients, 'Salami Rezept']
                  }));
                }} data-id="element-534">
                      <div className="w-5 h-5 border border-gray-300 rounded mr-3 flex items-center justify-center" data-id="element-535">
                        {formData.ingredients.includes('Salami Rezept') && <CheckIcon className="w-4 h-4 text-[#ec8301]" data-id="element-536" />}
                      </div>
                      <span className="text-gray-500 mr-2" data-id="element-537">R002</span>
                      Salami Rezept
                    </div>
                  </div>
                  {/* Divider */}
                  <div className="border-t border-gray-200 my-2" data-id="element-538"></div>
                  {/* Ingredients Section */}
                  <div className="px-4 py-2 bg-gray-50 text-sm font-medium text-gray-700" data-id="element-539">
                    Einzelne Rohstoffe
                  </div>
                  {Object.entries(groupedIngredients).filter(([category]) => !['Fleisch', 'Gewürze', 'Därme'].includes(category)).map(([category, ingredients]) => <div key={category} data-id="element-540">
                        <div className="px-4 py-2 bg-gray-100 text-sm font-medium text-gray-600" data-id="element-541">
                          {category}
                        </div>
                        {ingredients.map(ingredient => <div key={ingredient.id} className="px-4 py-2 hover:bg-gray-50 flex items-center cursor-pointer" onClick={() => handleIngredientToggle(ingredient.name)} data-id="element-542">
                            <div className="w-5 h-5 border border-gray-300 rounded mr-3 flex items-center justify-center" data-id="element-543">
                              {formData.ingredients.includes(ingredient.name) && <CheckIcon className="w-4 h-4 text-[#ec8301]" data-id="element-544" />}
                            </div>
                            <span className="text-gray-500 mr-2" data-id="element-545">
                              {ingredient.productNumber}
                            </span>
                            {ingredient.name}
                          </div>)}
                      </div>)}
                </div>}
            </div>
          </div>
          <div data-id="element-546">
            <h3 className="text-lg font-medium mb-4" data-id="element-547">Etikett</h3>
            <div className="space-y-4" data-id="element-548">
              <div className="flex gap-2" data-id="element-549">
                <select value={selectedLabelType} onChange={e => {
                setSelectedLabelType(e.target.value);
                updateLabel(e.target.value, selectedColor);
              }} className="flex-1 border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]" data-id="element-550">
                  <option value="" data-id="element-551">Etikettentyp auswählen...</option>
                  {labelTypes.map(type => <option key={type.id} value={type.id} data-id="element-552">
                      {type.name}
                    </option>)}
                </select>
                <div className="relative" data-id="element-553">
                  <button type="button" className="h-full px-4 border border-gray-300 rounded-lg flex items-center gap-2 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" onClick={() => setIsColorPickerOpen(!isColorPickerOpen)} disabled={!selectedLabelType} data-id="element-554">
                    <div className="w-4 h-4 rounded-full" style={{
                    backgroundColor: selectedColor.hex
                  }} data-id="element-555" />
                    <span data-id="element-556">{selectedColor.name}</span>
                  </button>
                  {isColorPickerOpen && <div className="absolute right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10" data-id="element-557">
                      {labelColors.map(color => <button key={color.id} type="button" className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-2" onClick={() => {
                    setSelectedColor(color);
                    setIsColorPickerOpen(false);
                    if (selectedLabelType) {
                      updateLabel(selectedLabelType, color);
                    }
                  }} data-id="element-558">
                          <div className="w-4 h-4 rounded-full" style={{
                      backgroundColor: color.hex
                    }} data-id="element-559" />
                          {color.name}
                        </button>)}
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <div data-id="element-560">
            <h3 className="text-lg font-medium mb-4" data-id="element-561">Etiketten pro Produkt</h3>
            <input type="number" name="labelsPerProduct" value={formData.labelsPerProduct || 1} onChange={handleInputChange} min="1" className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]" data-id="element-562" />
            <p className="text-sm text-gray-500 mt-1" data-id="element-563">
              Anzahl der Etiketten, die pro Produkt gedruckt werden müssen
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-3 mt-8 pt-6 border-t border-gray-200" data-id="element-564">
        <button type="button" onClick={() => {
        setIsIngredientsOpen(false);
        onCancel();
      }} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-565">
          Abbrechen
        </button>
        <button type="submit" className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-566">
          Speichern
        </button>
      </div>
    </form>;
}